<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Solicitudes de Campaña</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                        aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-xl-3 col-md-4 col-sm-12">
                                    <label class="col-form-label" for="Activa" title="Activa = plazo de presentación vigente">Activa</label> <label class="small">(Plazo de Presentación)</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Activa"
                                                    (onChange)="onChangeActiva($event)"
                                                    unselectable="true">
                                    </p-selectButton>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Filtra Campañas y Periodos)</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-md-4 col-sm-6">
                                    <label class="col-form-label" for="FechaInicioPresentacion">Inicio de Presentación</label>
                                    <p-calendar appendTo="body" formControlName="FechaInicioPresentacion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(de la/s solicitud/s)</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-md-4 col-sm-6">
                                    <label class="col-form-label" for="FechaFinPresentacion">Fin de Presentación</label>
                                    <p-calendar appendTo="body" formControlName="FechaFinPresentacion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(de la/s solicitud/s)</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-md-4 col-sm-6">
                                    <label class="col-form-label" for="IdCampania">Campaña</label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="campanias"
                                        [readonly]="!campanias || campanias.length === 0"
                                        bindLabel="Descripcion"
                                        bindValue="Id"
                                        formControlName="IdCampania"
                                        [loading]="campanias === null"
                                        placeholder="-- Seleccione una Campaña --"
                                        [ngClass]="displayFieldCssNgSelect('IdCampania')"
                                        (change)="onSelectCampania($event?.Id)"
                                        notFoundText="Campaña no encontrada"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Depende de "Activa")</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-md-4 col-sm-6">
                                    <label class="col-form-label" for="IdPeriodo">Periodo</label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="periodos"
                                        [readonly]="!periodos || periodos.length === 0"
                                        bindLabel="Descripcion"
                                        bindValue="Id"
                                        formControlName="IdPeriodo"
                                        [loading]="periodos === null && form.value.IdCampania !== null"
                                        placeholder="-- Seleccione un Periodo --"
                                        [ngClass]="displayFieldCssNgSelect('IdPeriodo')"
                                        (change)="onSelectPeriodo($event?.Id)"
                                        notFoundText="Periodo no encontrado"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Depende de "Activa" y "Campaña")</label>
                                    </div>
                                </div>

                                <div *ngIf="!isCA" class="form-group col-xl-3 col-md-4 col-sm-6">
                                    <label class="col-form-label" for="IdCA">Com. Autónoma</label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="CAs"
                                        [readonly]="!CAs || CAs.length === 0"
                                        placeholder="-- Seleccione una C.A. --"
                                        [loading]="CAs === null"
                                        bindLabel="ComunidadAutonoma"
                                        bindValue="IdCa"
                                        formControlName="IdCA"
                                        [ngClass]="displayFieldCssNgSelect('IdCA')"
                                        (change)="onSelectCA($event)"
                                        notFoundText="C.A. no encontrada"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.ComunidadAutonoma }}">{{ item.ComunidadAutonoma }}</div>
                                        </ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(Todas o del "Periodo")</label>
                                    </div>
                                </div>

                                <div *ngIf="!isEA" class="form-group col-xl-3 col-md-4 col-sm-6">
                                    <label class="col-form-label" for="IdEntidadAuditora">Entidad Auditora</label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="EAs"
                                        [readonly]="!EAs || EAs.length === 0 || form.value.IdCA === null || !entidadAuditoraEnabledForCA"
                                        placeholder="-- Seleccione una E.A. --"
                                        [loading]="(EAs === null && (form.value.IdCA !== null) && entidadAuditoraEnabledForCA)"
                                        bindLabel="Descripcion"
                                        bindValue="Id"
                                        formControlName="IdEntidadAuditora"
                                        [ngClass]="displayFieldCssNgSelect('IdEntidadAuditora')"
                                        notFoundText="E.A. no encontrada"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback tip d-block">
                                        <label>(depende de "Periodo" y "C.A.")</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-md-4 col-sm-6">
                                    <label class="col-form-label" for="IdTipoSolicitudCam">Tipo de Recinto </label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="tiposSolicitud"
                                        [readonly]="!tiposSolicitud || tiposSolicitud.length === 0"
                                        placeholder="-- Seleccione un Tipo de Recinto --"
                                        [loading]="tiposSolicitud === null"
                                        bindLabel="Descripcion"
                                        bindValue="Id"
                                        formControlName="IdTipoSolicitudCam"
                                        [ngClass]="displayFieldCssNgSelect('IdTipoSolicitudCam')"
                                        notFoundText="Tipo de Recinto no encontrado"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                    <div class="invalid-feedback tip d-block">
                                        <label ngbTooltip="PIAEd = Parcela-Invernadero-Almacén-Empresa Deshidratadora">("PIAEd")</label>
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-md-4 col-sm-6">
                                    <label class="col-form-label" for="Codigo">Código</label>
                                    <input formControlName="Codigo" name="Codigo" maxlength="50"
                                        class="form-control" id="Codigo" type="text" value="">
                                </div>

                                <div class="form-group col-xl-3 col-md-4 col-sm-6">
                                    <label class="col-form-label" for="SoloDevueltas">Solo Devueltas</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNo"
                                                    formControlName="SoloDevueltas"
                                                    (onChange)="onChangeSoloDevueltas($event)"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-xl-3 col-md-4 col-sm-6">
                                    <label class="col-form-label" for="IdEstadoSolicitudCam">Estado de la Solicitud</label>
                                    <ng-select appendTo="body" #selectEstado
                                        loadingText="Cargando..."
                                        [items]="estadosSolicitud"
                                        [readonly]="!estadosSolicitud || estadosSolicitud.length === 0"
                                        placeholder="-- Seleccione un Estado --"
                                        [loading]="estadosSolicitud === null"
                                        bindLabel="Descripcion"
                                        bindValue="Id"
                                        formControlName="IdEstadoSolicitudCam"
                                        [ngClass]="displayFieldCssNgSelect('IdEstadoSolicitudCam')"
                                        notFoundText="Estado no encontrado"
                                        (change)="onSelectEstado($event)"
                                        clearAllText="Eliminar selección">

                                        <!-- una template para el label -->
                                        <ng-template ng-label-tmp let-item="item">
                                            <img src="{{ item.Id | IconoEstadoSolicitudCam }}" ngbTooltip="{{ item.Descripcion }}" />
                                            <span ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</span>
                                        </ng-template>

                                        <!-- una template para el option -->
                                        <ng-template ng-option-tmp let-item="item"  let-index="index">
                                            <img src="{{ item.Id | IconoEstadoSolicitudCam }}" ngbTooltip="{{ item.Descripcion }}" />
                                            <span ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</span>
                                        </ng-template>
                                        
                                    </ng-select>
                                </div>

                                <div *ngIf="!isOperadorCam" class="form-group col-xl-3 col-md-4 col-sm-6">
                                    <label class="col-form-label" for="Operador">Operador</label>
                                    <input formControlName="Operador" name="Operador" maxlength="50"
                                        class="form-control" id="Operador" type="text" value="">
                                </div>                                

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                            [disabled]="disableSearchBtn" title="Realiza una búsqueda" (click)="onSearch($event)">
                                                <i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button"
                                            [disabled]="formIsUntouched()"
                                            title="Limpia los filtros" (click)="resetForm($event)">
                                                <i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</form>

